module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-wrap"
  }, [_c('div', {
    staticClass: "changeType"
  }, [_c('div', {
    staticClass: "nav-item",
    on: {
      "click": _vm.clickSatellite
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/dashboard/map-type-2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("卫星地图")])]), _vm._v(" "), _c('div', {
    staticClass: "nav-item",
    on: {
      "click": _vm.clickNormal
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/dashboard/map-type-1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("平面图")])])]), _vm._v(" "), _c('div', {
    staticClass: "map"
  }, [(!_vm.ifSatellite) ? _c('mapChart') : _c('satelliteMap')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0aca34d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/center/centerMap/index.vue
// module id = 1933
// module chunks = 2